import {VisitaModel} from './visita.model';
import {PreguntaModel} from './pregunta.model';

export class ResultadoModel {
  pregunta?: string;
  respuesta: number = 1;
  observacion: string = '';
  estado: number = 0;
  fotos:string[] = [];

  toJSON() {
    return {
      pregunta: this.pregunta,
      respuesta: this.respuesta,
      observacion: this.observacion,
      estado: this.estado
    };
  }

  static newResultado(data: any):ResultadoModel {
    let r = new ResultadoModel();
    r.pregunta = data.pregunta;
    r.respuesta = data.respuesta;
    r.observacion = data.observacion;
    r.estado = data.estado;

     return r;
  }

  public devolverResStr(): string {
    switch (this.respuesta) {
      case 1:
        return 'Si';
        break;
      case -1:
        return 'No';
        break;
      default:
        return 'N/A';
    }
  }

  public devolverClase():string{
    switch (this.respuesta) {
      case 1:
        return 'rSi';
        break;
      case -1:
        return 'rNo';
        break;
      default:
        return 'rNA';
    }
  }
}
